import ChatTranslations from './chat.trans'
import ChatMessageTranslations from './components/chat-message/translations'

export default {
  ...ChatTranslations,
  ...ChatMessageTranslations,
}
